import { render, staticRenderFns } from "./UserEditAllowedOffices.vue?vue&type=template&id=085a556d&"
import script from "./UserEditAllowedOffices.vue?vue&type=script&lang=js&"
export * from "./UserEditAllowedOffices.vue?vue&type=script&lang=js&"
import style0 from "./UserEditAllowedOffices.vue?vue&type=style&index=0&id=085a556d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports